import { render, staticRenderFns } from "./empresa01.vue?vue&type=template&id=47d031a0&scoped=true&"
import script from "./empresa01.vue?vue&type=script&lang=js&"
export * from "./empresa01.vue?vue&type=script&lang=js&"
import style0 from "./empresa01.vue?vue&type=style&index=0&id=47d031a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d031a0",
  null
  
)

component.options.__file = "empresa01.vue"
export default component.exports